/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { paletteTokens } from './paletteVariables';

export const getDarkThemeVariables = (palette = paletteTokens) =>
  ({
    button: {
      primary: {
        default: palette.brand.primary[100],
        hover: palette.brand.primary[150],
        pressed: palette.brand.primary[100],
        label: palette.dynamicContrast.primary[100],
        border: palette.neutral.darkAlpha[650],
        disabled: palette.neutral.lightAlpha[600],
      },
      secondary: {
        default: palette.neutral.lightAlpha[550],
        hover: palette.neutral.lightAlpha[400],
        pressed: palette.neutral.lightAlpha[450],
        disabled: palette.neutral.lightAlpha[600],
        label: palette.neutral.grey[100],
        border: palette.neutral.darkAlpha[650],
      },
      ghost: {
        hover: palette.neutral.grey[250],
        pressed: palette.neutral.grey[350],
        disabled: palette.neutral.grey[450],
        default: palette.neutral.grey[150],
      },
      outline: {
        default: palette.neutral.grey[600],
        hover: palette.neutral.grey[550],
        pressed: palette.neutral.grey[500],
        label: palette.neutral.grey[100],
      },
      destructive: {
        default: palette.alert.negative[350],
        hover: palette.alert.negative[350],
        pressed: palette.alert.negative[350],
        disabled: palette.neutral.lightAlpha[600],
        label: palette.neutral.grey[100],
        border: palette.neutral.darkAlpha[650],
      },
      upgrade: {
        default: palette.pro.primary[100],
        hover: palette.pro.primary[150],
        pressed: palette.pro.primary[200],
        disabled: palette.neutral.lightAlpha[600],
        label: palette.neutral.grey[100],
        border: palette.neutral.darkAlpha[650],
      },
      disabled: { label: palette.neutral.grey[500] },
      focused: {
        default: palette.neutral.grey[100],
        upgrade: palette.pro.primary[100],
        desctructive: palette.alert.negative[350],
      },
      divider: {
        dark: palette.neutral.darkAlpha[450],
        light: palette.neutral.lightAlpha[450],
      },
      secondaryAlt: {
        default: palette.neutral.lightAlpha[450],
        hover: palette.neutral.lightAlpha[400],
        pressed: palette.neutral.lightAlpha[400],
        disabled: palette.neutral.lightAlpha[600],
        label: palette.neutral.grey[100],
        border: palette.neutral.darkAlpha[650],
      },
      link: {
        default: palette.brand.primary[100],
        hover: palette.brand.primary[150],
        pressed: palette.brand.primary[200],
        disabled: palette.neutral.grey[450],
      },
      outlineDestructive: {
        default: palette.neutral.grey[600],
        hover: palette.neutral.grey[550],
        pressed: palette.neutral.grey[500],
        label: palette.alert.negative[350],
      },
      loading: { label: palette.neutral.grey[100] },
    },
    text: {
      generic: {
        primary: palette.neutral.grey[100],
        secondary: palette.neutral.grey[200],
        tertiary: palette.neutral.grey[400],
        badge: palette.neutral.grey[100],
        brandLight: palette.brand.primary[100],
        brand: palette.brand.secondary[100],
        positive: palette.alert.positive[350],
        warning: palette.alert.notice[350],
        negative: palette.alert.negative[250],
      },
      interactive: {
        active: palette.brand.secondary[20],
        disabled: palette.neutral.grey[450],
        default: palette.neutral.grey[100],
      },
      link: {
        default: palette.brand.primary[100],
        hover: palette.brand.primary[150],
        disabled: palette.neutral.grey[450],
      },
    },
    background: {
      interactive: {
        canvas: palette.neutral.grey[850],
        hover: palette.neutral.grey[750],
        inactive: palette.neutral.grey[700],
        canvasHover: palette.neutral.grey[200],
        selected: palette.neutral.grey[700],
        disabledHover: palette.neutral.grey[800],
      },
      primary: palette.neutral.lightAlpha[600],
      secondary: palette.neutral.grey[700],
      tertiary: palette.neutral.grey[250],
      default: {
        noCamera: palette.neutral.grey[850],
        backend: palette.neutral.grey[150],
        fullwhite: palette.neutral.grey[100],
        fixedheader: palette.pro.secondary[10],
        icon: palette.neutral.lightAlpha[350],
        preview: palette.neutral.grey[300],
      },
      dimmingLayer: palette.neutral.darkAlpha[300],
      dimmingLayerLight: palette.neutral.darkAlpha[450],
    },
    icon: {
      primary: palette.neutral.grey[100],
      onBrand: palette.neutral.grey[100],
      interactive: {
        disabled: palette.neutral.grey[500],
        default: palette.neutral.grey[200],
        hover: palette.neutral.grey[200],
        negative: palette.alert.negative[350],
        upgrade: palette.pro.primary[100],
        active: palette.brand.primary[100],
      },
      positive: palette.alert.positive[350],
      notice: palette.alert.notice[350],
      negative: palette.alert.negative[350],
      secondary: palette.neutral.grey[350],
      brand: palette.brand.secondary[100],
      tertiary: palette.neutral.grey[450],
      brandlight: palette.brand.primary[100],
      upgrade: palette.pro.primary[100],
    },
    border: {
      brand: palette.brand.secondary[100],
      primary: palette.neutral.lightAlpha[550],
      interactive: {
        hover: palette.neutral.grey[300],
        disabled: palette.neutral.lightAlpha[550],
        default: palette.brand.primary[100],
        negative: palette.alert.negative[300],
        negativeHover: palette.alert.negative[350],
        pressed: palette.neutral.grey[500],
        selected: palette.brand.primary[50],
        negativeFocused: palette.alert.negative[550],
        defaultFocused: palette.brand.primary[50],
        upgradeFocused: palette.pro.primary[250],
        indicatorFocused: palette.neutral.grey[100],
        indicatorNegativeFocused: palette.alert.negative[350],
        indicatorUpgradeFocused: palette.pro.primary[100],
      },
      secondary: palette.neutral.grey[100],
      tertiary: palette.neutral.lightAlpha[500],
      default: palette.neutral.lightAlpha[550],
    },
    input: {
      background: {
        default: palette.neutral.lightAlpha[600],
        disabled: palette.neutral.lightAlpha[650],
      },
      border: {
        default: palette.neutral.lightAlpha[550],
        active: palette.brand.primary[100],
        error: palette.alert.negative[300],
        errorActive: palette.alert.negative[350],
        focused: palette.brand.primary[50],
        errorFocused: palette.alert.negative[550],
      },
    },
    tooltip: {
      background: palette.neutral.grey[900],
      border: palette.neutral.lightAlpha[550],
    },
    switch: {
      default: {
        default: palette.neutral.grey[550],
        hover: palette.neutral.grey[500],
        pressed: palette.neutral.grey[450],
        disabled: palette.neutral.grey[600],
      },
      active: {
        default: palette.brand.primary[100],
        hover: palette.brand.primary[150],
        pressed: palette.brand.primary[200],
        disabled: palette.brand.primary[50],
      },
      knob: {
        default: palette.neutral.grey[150],
        disabled: palette.neutral.grey[500],
      },
    },
    toast: {
      notification: {
        background: palette.neutral.grey[850],
        border: palette.neutral.grey[650],
      },
    },
    keystroke: {
      background: palette.neutral.lightAlpha[600],
      border: palette.neutral.lightAlpha[550],
    },
    popover: {
      background: palette.neutral.darkAlpha[200],
      border: palette.neutral.lightAlpha[550],
    },
    incall: {
      icon: {
        background: {
          interactive: {
            default: palette.neutral.lightAlpha[600],
            hover: palette.neutral.darkAlpha[300],
            active: palette.neutral.darkAlpha[200],
            disabled: palette.neutral.darkAlpha[350],
            navigation: palette.neutral.lightAlpha[600],
          },
        },
        fill: {
          interactive: {
            default: palette.neutral.lightAlpha[250],
            hover: palette.neutral.lightAlpha[150],
            active: palette.brand.primary[100],
            disabled: palette.neutral.lightAlpha[350],
          },
        },
      },
      text: {
        interactive: { disabled: palette.neutral.darkAlpha[200] },
        input: palette.neutral.grey[950],
        placeholder: palette.neutral.grey[450],
      },
      background: {
        canvasDark: palette.neutral.grey[850],
        canvasLight: palette.neutral.grey[750],
        base: palette.neutral.lightAlpha[600],
      },
      nametag: {
        background: palette.neutral.grey[800],
        border: palette.neutral.grey[650],
      },
      controlbar: {
        cells: {
          hover: palette.neutral.grey[600],
          selected: palette.neutral.lightAlpha[100],
          selectedHover: palette.neutral.lightAlpha[150],
          default: palette.neutral.grey[650],
          active: palette.neutral.grey[700],
          negative: palette.alert.negative[350],
          negativeHover: palette.alert.negative[400],
        },
        icons: {
          default: palette.neutral.grey[100],
          disabled: palette.neutral.grey[500],
          upgrade: palette.pro.primary[100],
          negative: palette.alert.negative[350],
          active: palette.brand.primary[200],
        },
        base: {
          background: palette.neutral.grey[850],
          border: 'rgba(255, 255, 255, 0)',
        },
      },
      controls: {
        cell: {
          default: palette.neutral.grey[750],
          hover: palette.neutral.grey[600],
          border: 'rgba(255, 255, 255, 0)',
          disabled: palette.neutral.grey[650],
          active: palette.neutral.grey[600],
        },
        icons: {
          default: palette.neutral.grey[100],
          disabled: palette.neutral.grey[500],
        },
      },
      tab: {
        cells: {
          default: 'rgba(255, 255, 255, 0)',
          active: palette.neutral.lightAlpha[600],
          hover: palette.neutral.grey[700],
          selected: 'rgba(255, 255, 255, 0)',
        },
        icons: { default: palette.neutral.grey[100] },
      },
      timer: { background: palette.neutral.grey[700] },
    },
    iconButton: {
      icon: {
        default: palette.neutral.grey[200],
        disabled: palette.neutral.grey[550],
        destructive: palette.alert.negative[350],
        defaultAlpha: palette.neutral.grey[200],
      },
      background: {
        default: {
          disabled: palette.neutral.grey[750],
          default: palette.neutral.grey[750],
          hover: palette.neutral.grey[650],
          active: palette.neutral.grey[600],
          pressed: palette.neutral.grey[650],
          focused: palette.neutral.grey[750],
          disabledHover: palette.neutral.grey[750],
        },
        subtle: {
          default: 'rgba(255, 255, 255, 0)',
          disabled: 'rgba(255, 255, 255, 0)',
          focused: palette.neutral.lightAlpha[500],
          active: palette.neutral.lightAlpha[450],
          disabledHover: palette.neutral.lightAlpha[650],
          pressed: palette.neutral.lightAlpha[450],
          hover: palette.neutral.lightAlpha[550],
        },
        tinted: {
          disabled: 'rgba(255, 255, 255, 0)',
          pressed: palette.neutral.lightAlpha[450],
          default: 'rgba(255, 255, 255, 0)',
          hover: palette.neutral.lightAlpha[550],
          disabledHover: palette.neutral.lightAlpha[650],
          active: palette.neutral.lightAlpha[450],
          focused: palette.neutral.lightAlpha[500],
        },
        tintedWithStroke: {
          default: 'rgba(255, 255, 255, 0)',
          hover: palette.neutral.lightAlpha[550],
          pressed: palette.neutral.lightAlpha[450],
          focused: palette.neutral.lightAlpha[500],
          active: palette.neutral.lightAlpha[450],
          disabled: 'rgba(255, 255, 255, 0)',
          disabledHover: palette.neutral.lightAlpha[650],
          border: palette.neutral.lightAlpha[400],
        },
        defaultDestructive: {
          default: palette.neutral.lightAlpha[500],
          hover: palette.alert.negative[600],
          pressed: palette.alert.negative[600],
          focused: palette.alert.negative[600],
          active: palette.alert.negative[550],
          disabled: palette.neutral.lightAlpha[500],
          disabledHover: palette.neutral.lightAlpha[650],
        },
        subtleDestructive: {
          default: 'rgba(255, 255, 255, 0)',
          hover: palette.alert.negative[600],
          pressed: palette.alert.negative[600],
          focused: palette.alert.negative[600],
          active: palette.alert.negative[550],
          disabled: 'rgba(255, 255, 255, 0)',
          disabledHover: palette.neutral.lightAlpha[650],
        },
        tintedDestructive: {
          default: 'rgba(255, 255, 255, 0)',
          hover: palette.alert.negative[600],
          pressed: palette.alert.negative[600],
          focused: palette.alert.negative[600],
          active: palette.alert.negative[550],
          disabled: 'rgba(255, 255, 255, 0)',
          disabledHover: palette.neutral.lightAlpha[650],
        },
        tintedwithstrokeDestructive: {
          default: 'rgba(255, 255, 255, 0)',
          hover: palette.alert.negative[600],
          pressed: palette.alert.negative[600],
          focused: palette.alert.negative[600],
          active: palette.alert.negative[550],
          disabled: 'rgba(255, 255, 255, 0)',
          disabledHover: palette.neutral.lightAlpha[650],
          border: palette.neutral.grey[600],
        },
        defaultAlpha: {
          default: palette.neutral.darkAlpha[300],
          hover: palette.neutral.darkAlpha[350],
          pressed: palette.neutral.darkAlpha[400],
          focused: palette.neutral.darkAlpha[450],
          active: palette.neutral.darkAlpha[400],
          disabled: palette.neutral.darkAlpha[700],
          disabledHover: palette.neutral.darkAlpha[650],
        },
        defaultAlphaDestructive: {
          default: palette.neutral.lightAlpha[500],
          hover: palette.alert.negative[600],
          pressed: palette.alert.negative[600],
          focused: palette.alert.negative[600],
          active: palette.alert.negative[550],
          disabled: palette.neutral.lightAlpha[500],
          disabledHover: palette.neutral.lightAlpha[650],
        },
      },
    },
    menu: {
      background: {
        default: palette.neutral.grey[900],
        hover: palette.neutral.grey[750],
        selected: palette.neutral.grey[700],
        border: palette.neutral.grey[700],
        destructiveHover: palette.alert.negative[600],
        disabledHover: palette.neutral.grey[800],
      },
      item: {
        default: palette.neutral.grey[100],
        hover: palette.neutral.grey[100],
        selected: palette.neutral.grey[100],
        disabled: palette.neutral.grey[450],
      },
    },
    sidebar: {
      background: {
        active: palette.brand.secondary[30],
        hover: palette.brand.secondary[20],
      },
    },
    item: {
      selected: palette.brand.secondary[100],
      default: palette.neutral.grey[550],
    },
    modal: {
      background: palette.neutral.grey[900],
      border: palette.neutral.lightAlpha[550],
      cell: palette.neutral.lightAlpha[600],
      divider: palette.neutral.grey[600],
      headerBackground: palette.neutral.darkAlpha[450],
      hover: palette.neutral.grey[700],
    },
    patientQueuePanels: {
      background: palette.neutral.grey[850],
      border: palette.neutral.lightAlpha[550],
      cell: palette.neutral.lightAlpha[600],
    },
    radioButton: {
      default: {
        default: palette.neutral.grey[500],
        hover: palette.brand.primary[100],
        pressed: palette.brand.primary[200],
        disabled: palette.neutral.grey[650],
      },
      active: {
        default: palette.brand.primary[100],
        hover: palette.brand.primary[150],
        pressed: palette.brand.primary[200],
        disabled: palette.neutral.grey[650],
      },
      background: palette.neutral.lightAlpha[600],
      selector: {
        default: palette.dynamicContrast.primary[100],
        disabled: palette.neutral.grey[500],
      },
    },
    segmentedControl: {
      background: palette.neutral.lightAlpha[550],
      default: {
        border: 'rgba(255, 255, 255, 0)',
        background: 'rgba(255, 255, 255, 0)',
        text: palette.neutral.grey[100],
      },
      hover: {
        background: palette.neutral.lightAlpha[600],
        border: 'rgba(255, 255, 255, 0)',
        text: palette.neutral.grey[100],
      },
      active: {
        background: palette.neutral.grey[100],
        border: palette.neutral.grey[650],
        text: palette.neutral.grey[800],
      },
    },
    checkbox: {
      background: palette.neutral.lightAlpha[600],
      default: {
        default: palette.neutral.grey[500],
        hover: palette.brand.primary[100],
        pressed: palette.brand.primary[200],
      },
      active: {
        default: palette.brand.primary[100],
        hover: palette.brand.primary[150],
        pressed: palette.brand.primary[200],
        disabled: palette.neutral.grey[650],
      },
      disabled: {
        background: palette.neutral.grey[650],
        border: palette.neutral.grey[600],
      },
      error: {
        error: palette.alert.negative[300],
        hover: palette.alert.negative[350],
        pressed: palette.alert.negative[250],
      },
      container: {
        default: palette.neutral.grey[200],
        error: palette.alert.negative[100],
      },
      selector: {
        default: palette.dynamicContrast.primary[100],
        disabled: palette.neutral.grey[500],
      },
    },
    filter: {
      default: palette.neutral.lightAlpha[500],
      hover: palette.neutral.grey[750],
      active: palette.neutral.grey[700],
      disabled: palette.neutral.lightAlpha[650],
    },
    callout: {
      neutral: palette.neutral.grey[750],
      success: palette.alert.positive[550],
      informative: palette.alert.informative[550],
      notice: palette.alert.notice[550],
      error: palette.alert.negative[600],
      upgrade: palette.pro.secondary[10],
      beta: palette.brand.secondary[20],
    },
    badge: {
      upgrade: {
        active: palette.pro.primary[100],
        text: palette.neutral.grey[100],
      },
      inactive: {
        text: palette.neutral.grey[550],
        background: palette.neutral.grey[250],
      },
      marketing: {
        background: palette.brand.primary[100],
        text: palette.dynamicContrast.primary[100],
      },
      beta: {
        background: palette.neutral.darkAlpha[200],
        text: palette.neutral.grey[100],
        stroke: palette.neutral.grey[100],
      },
      new: {
        active: palette.brand.tertiary[100],
        text: palette.neutral.grey[100],
      },
    },
    subscription: {
      proFeatureContainer: {
        background: palette.pro.secondary[25],
        border: palette.pro.primary[15],
      },
      upgradeIcon: {
        icon: palette.pro.primary[100],
        background: palette.pro.primary[15],
      },
    },
    connectionStatus: {
      base: palette.neutral.grey[100],
      active: {
        good: palette.alert.positive[300],
        medium: palette.alert.notice[300],
        poor: palette.alert.negative[300],
        none: palette.alert.negative[150],
      },
      inactive: {
        good: palette.alert.positive[550],
        medium: palette.alert.notice[550],
        poor: palette.alert.negative[500],
      },
    },
    status: {
      positive: palette.alert.positive[350],
      negative: palette.alert.negative[350],
      notice: palette.alert.notice[350],
      informative: palette.alert.informative[350],
      neutral: palette.neutral.grey[550],
      baseLight: palette.neutral.grey[100],
      baseDark: palette.neutral.grey[900],
      border: palette.neutral.grey[700],
    },
    numberBadge: {
      alert: {
        background: palette.alert.informative[350],
        text: palette.neutral.grey[100],
      },
      default: {
        background: palette.neutral.grey[700],
        text: palette.neutral.grey[100],
      },
      list: {
        background: palette.brand.primary[100],
        text: palette.dynamicContrast.primary[100],
      },
      plain: {
        background: palette.neutral.lightAlpha[700],
        text: palette.neutral.grey[400],
        border: palette.neutral.lightAlpha[600],
      },
      message: {
        background: palette.alert.informative[400],
        text: palette.neutral.grey[100],
      },
    },
    dashboard: {
      navigation: {
        background: {
          default: 'rgba(255, 255, 255, 0)',
          hover: palette.neutral.grey[250],
          selected: palette.neutral.grey[300],
        },
        label: {
          default: palette.neutral.grey[450],
          hover: palette.neutral.grey[100],
          selected: palette.neutral.grey[100],
          disabled: palette.neutral.grey[450],
        },
        avatarborder: {
          default: palette.brand.secondary[50],
          hover: palette.brand.secondary[50],
          selected: palette.brand.secondary[50],
        },
      },
      default: palette.brand.secondary[50],
      hover: palette.brand.secondary[50],
      selected: palette.brand.secondary[50],
      content: {
        background: palette.neutral.grey[125],
        border: palette.neutral.grey[300],
      },
    },
    form: { divider: { border: palette.neutral.grey[700] } },
    tabbar: {
      bar: { background: palette.neutral.grey[125] },
      tabs: {
        default: {
          background: palette.neutral.grey[100],
          border: palette.neutral.grey[400],
          label: palette.neutral.grey[400],
        },
        hover: {
          background: palette.neutral.grey[250],
          border: palette.neutral.grey[400],
          label: palette.neutral.grey[400],
        },
        selected: {
          background: palette.neutral.grey[400],
          border: palette.neutral.grey[400],
          label: palette.neutral.grey[100],
        },
      },
    },
    datepicker: {
      base: {
        background: palette.neutral.darkAlpha[200],
        border: palette.neutral.lightAlpha[550],
      },
      cells: {
        default: palette.neutral.grey[100],
        hover: palette.neutral.grey[250],
        selected: palette.neutral.grey[400],
        todayborder: palette.neutral.grey[400],
        selctedinbetween: palette.neutral.grey[150],
      },
    },
    interactiveTag: {
      default: { background: palette.neutral.grey[600] },
      hover: { background: palette.neutral.grey[250] },
      focused: {
        background: palette.brand.primary[25],
        border: palette.brand.primary[100],
      },
      error: { background: palette.alert.negative[600] },
      errorFocused: {
        border: palette.alert.negative[300],
        background: palette.alert.negative[100],
      },
      new: {
        background: palette.brand.primary[25],
        text: palette.brand.primary[200],
        icon: palette.brand.primary[200],
      },
    },
    videotile: {
      noCamera: palette.neutral.grey[900],
      disabled: palette.neutral.grey[200],
      border: palette.neutral.lightAlpha[550],
      speakingBorder: palette.brand.primary[100],
    },
    rating: {
      default: palette.neutral.grey[450],
      hover: palette.brand.tertiary[100],
      selected: palette.brand.tertiary[100],
    },
    chatBubbles: {
      receivedMessage: {
        background: palette.neutral.lightAlpha[500],
        text: palette.neutral.grey[100],
      },
      sentMessage: {
        background: palette.brand.secondary[80],
        text: palette.neutral.grey[100],
      },
    },
    patientTileOptions: {
      default: {
        background: palette.neutral.lightAlpha[600],
        icon: palette.neutral.grey[100],
        label: palette.neutral.grey[100],
      },
      hover: {
        background: palette.neutral.darkAlpha[200],
        icon: palette.neutral.grey[100],
        label: palette.neutral.grey[100],
      },
      active: {
        background: palette.neutral.lightAlpha[100],
        icon: palette.brand.primary[200],
        label: palette.neutral.grey[100],
      },
      disabled: {
        background: palette.neutral.grey[750],
        icon: palette.neutral.grey[500],
        label: palette.neutral.grey[450],
      },
      hoverDestructive: {
        background: palette.alert.negative[350],
        label: palette.neutral.grey[100],
        icon: palette.neutral.grey[100],
      },
    },
    tableCells: {
      default: {
        background: palette.neutral.grey[125],
        border: palette.neutral.grey[700],
      },
      hover: {
        background: palette.neutral.grey[750],
        border: palette.neutral.grey[700],
      },
      header: {
        background: palette.neutral.grey[125],
        border: palette.neutral.grey[700],
      },
    },
    virtualBackground: {
      setting: {
        default: palette.neutral.lightAlpha[600],
        hover: palette.neutral.lightAlpha[550],
        selected: palette.neutral.lightAlpha[550],
        disabled: palette.neutral.lightAlpha[600],
      },
      image: {
        default: palette.neutral.darkAlpha[700],
        hover: palette.neutral.darkAlpha[550],
        selected: palette.neutral.darkAlpha[450],
      },
    },
    location: { border: palette.neutral.lightAlpha[400] },
    banner: { background: palette.pro.secondary[10] },
    avatar: {
      background: palette.neutral.grey[600],
      fallback: palette.neutral.grey[600],
    },
    swatch: {
      default: {
        border: palette.neutral.darkAlpha[600],
        background: palette.neutral.grey[100],
      },
    },
    selectionCard: {
      default: {
        true: palette.neutral.grey[850],
        border: palette.neutral.grey[750],
      },
      hover: {
        true: palette.neutral.grey[800],
        border: palette.neutral.grey[750],
      },
      disabled: {
        true: palette.neutral.grey[850],
        border: palette.neutral.grey[750],
      },
    },
    avatarGroup: {
      border: palette.neutral.grey[800],
      counter: palette.neutral.grey[600],
    },
    typingBubbles: {
      1: palette.neutral.grey[500],
      2: palette.neutral.grey[450],
      3: palette.neutral.grey[300],
    },
    paymentSummary: { background: palette.brand.secondary[20] },
    fileContainer: {
      iconBackground: palette.neutral.grey[900],
      background: palette.neutral.grey[750],
      backgroundSecondary: palette.neutral.grey[750],
      strokeSecondary: palette.neutral.grey[750],
    },
    pricingCard: {
      background: palette.neutral.grey[100],
      border: palette.neutral.grey[350],
    },
    microphone: {
      base: palette.brand.secondary[40],
      fork: palette.brand.secondary[100],
      active: palette.brand.primary[100],
      disabled: palette.neutral.grey[500],
    },
    loader: {
      status: palette.brand.primary[200],
      background: palette.brand.primary[50],
    },
    header: { background: palette.neutral.grey[850] },
    preview: { background: palette.brand.secondary[30] },
    googleButton: {
      default: palette.neutral.lightAlpha[550],
      hover: palette.neutral.lightAlpha[400],
      pressed: palette.neutral.lightAlpha[450],
      disabled: palette.neutral.lightAlpha[600],
      label: palette.neutral.grey[100],
      border: palette.neutral.lightAlpha[600],
    },
    alertBanner: {
      background: {
        success: palette.alert.positive[550],
        negative: palette.alert.negative[600],
        alert: palette.alert.notice[550],
        informative: palette.alert.informative[550],
      },
      copy: {
        success: palette.neutral.grey[800],
        negative: palette.neutral.grey[100],
        alert: palette.neutral.grey[800],
        informative: palette.neutral.grey[100],
      },
      icon: {
        success: palette.neutral.grey[800],
        negative: palette.neutral.grey[100],
        alert: palette.neutral.grey[800],
        informative: palette.alert.informative[100],
      },
    },
    progressBar: {
      default: palette.neutral.grey[300],
      filled: palette.brand.primary[100],
    },
    pagination: {
      cells: {
        hover: palette.neutral.grey[750],
        selected: palette.neutral.grey[700],
        default: palette.neutral.grey[125],
      },
      base: {
        background: palette.neutral.grey[125],
        border: palette.neutral.grey[700],
      },
    },
    waitingRoom: {
      background: {
        default: palette.neutral.grey[150],
        card: palette.neutral.grey[100],
        section: palette.neutral.grey[150],
        numberedList: palette.brand.primary[200],
      },
    },
    knob: {
      base: {
        default: palette.neutral.grey[100],
        hover: palette.neutral.grey[150],
        pressed: palette.neutral.grey[100],
        focused: palette.neutral.grey[100],
        disabled: palette.neutral.grey[500],
      },
      stroke: {
        default: palette.neutral.darkAlpha[600],
        hover: palette.neutral.darkAlpha[600],
        pressed: palette.neutral.darkAlpha[600],
        focused: palette.brand.primary[50],
        disabled: palette.neutral.darkAlpha[500],
      },
    },
    slider: {
      track: {
        active: palette.brand.primary[100],
        inactive: palette.brand.primary[50],
        disabledInactive: palette.neutral.grey[450],
        disabledActive: palette.neutral.grey[500],
      },
      dash: { default: palette.neutral.lightAlpha[200] },
    },
    eMDR: {
      background: {
        dark: palette.neutral.grey[800],
        light: palette.neutral.grey[150],
      },
      dot: {
        /**
         * Legacy dot colours, each coupled to a specific background
         * (`*OnDark` / `*OnLight`). Consumed by the legacy `ColorControls`
         * picker in `apps/extensions/emdr` via `getColorOptions(theme)`.
         * Slated for removal once `ColorControls` is replaced by the new
         * `DotColorControls` + standalone Background panel (PROD-8424
         * follow-up).
         */
        blueOnDark: palette.tint.blue[350],
        blueOnLight: palette.alert.informative[350],
        orangeOnLight: palette.tint.orange[350],
        orangeOnDark: palette.tint.coral[350],
        whiteOnDark: palette.neutral.grey[400],
        greyOnLight: palette.neutral.grey[600],
        /**
         * Background-agnostic dot colours used by the new EMDR Dot color
         * panel (`DotColorControls`). Added in PROD-8424 and gated by the
         * `feat_prod_8422_emdr_directions` flag (shared with direction
         * controls). Replaces the legacy `*OnDark` / `*OnLight` keys above
         * once the legacy `ColorControls` picker is retired.
         */
        blue: palette.alert.informative[350],
        green: palette.alert.positive[350],
        yellow: palette.alert.notice[300],
        orange: palette.tint.orange[350],
        lightGrey: palette.neutral.grey[400],
        darkGrey: palette.neutral.grey[600],
        hover: palette.neutral.darkAlpha[550],
      },
      stroke: {
        selected: palette.brand.primary[100],
        default: palette.neutral.grey[600],
      },
    },
    apps: {
      background: {
        primaryContainer: palette.neutral.grey[850],
        secondaryContainer: palette.neutral.grey[650],
      },
      menuCards: {
        background: {
          default: palette.neutral.grey[650],
          hover: palette.neutral.grey[600],
        },
        stroke: { default: palette.neutral.lightAlpha[600] },
        assetBackground: { default: palette.neutral.lightAlpha[600] },
      },
      memoryGameCards: {
        background: {
          default: palette.brand.tertiary[10],
          success: palette.alert.positive[350],
        },
      },
      appreciationSpace: {
        selectionCards: {
          background: {
            default: palette.neutral.grey[650],
            hover: palette.neutral.grey[600],
          },
        },
        canvasCards: {
          background: palette.neutral.grey[100],
          stroke: palette.neutral.grey[350],
        },
      },
    },
    viewModeBanner: {
      background: palette.neutral.darkAlpha[200],
      border: palette.neutral.lightAlpha[550],
    },
    textBadge: {
      default: {
        background: palette.alert.informative[350],
        text: palette.neutral.grey[100],
      },
    },
    loadingSpinner: {
      background: palette.neutral.lightAlpha[400],
      form: palette.neutral.lightAlpha[100],
    },
    appsFlyout: {
      cells: {
        default: palette.neutral.grey[100],
        hover: palette.neutral.grey[100],
        selected: palette.neutral.grey[100],
        disabled: palette.neutral.grey[450],
      },
    },
    active: palette.pro.primary[100],
    planBadge: {
      free: {
        border: palette.neutral.grey[550],
        text: palette.neutral.grey[400],
      },
      pro: {
        background: palette.pro.primary[100],
        text: palette.neutral.grey[100],
      },
      clinic: {
        background: palette.neutral.grey[600],
        text: palette.neutral.grey[100],
      },
    },
    scrollBar: { background: palette.neutral.lightAlpha[350] },
    illustration: {
      strokes: palette.neutral.grey[500],
      filling: palette.neutral.grey[500],
    },
    dropZone: {
      stroke: {
        default: palette.neutral.lightAlpha[300],
        activeHover: palette.brand.primary[100],
        disabled: palette.neutral.lightAlpha[550],
        hover: palette.neutral.lightAlpha[300],
      },
      background: {
        activeHover: palette.brand.primary[50],
        default: palette.neutral.grey[900],
        disabled: palette.neutral.lightAlpha[650],
        hover: palette.neutral.lightAlpha[650],
      },
    },
    timer: {
      countdown: {
        track: palette.neutral.grey[500],
        indicator: palette.brand.primary[150],
      },
      previewSelection: {
        hover: palette.neutral.lightAlpha[500],
        active: palette.brand.primary[50],
      },
      preset: {
        stroke: {
          default: palette.neutral.lightAlpha[550],
          hover: palette.brand.primary[150],
          active: palette.brand.primary[100],
        },
        background: {
          default: palette.neutral.lightAlpha[600],
          disabled: palette.neutral.lightAlpha[650],
        },
      },
    },
    blinkingCursor: { cursor: palette.neutral.grey[100] },
    beta: {
      icon: {
        icon: palette.brand.secondary[80],
        background: palette.brand.secondary[40],
      },
    },
    documentationWrapper: {
      background: palette.neutral.grey[900],
      copy: palette.brand.tertiary[100],
      border: palette.neutral.grey[550],
      backgroundBadge: palette.neutral.grey[750],
    },
    appLibraryInfoCard: {
      stroke: palette.neutral.lightAlpha[300],
      background: palette.neutral.lightAlpha[600],
    },
    videoPlayerOverlay: {
      default: palette.neutral.darkAlpha[700],
      hover: palette.neutral.darkAlpha[600],
    },
    playButton: {
      stroke: {
        default: palette.neutral.lightAlpha[200],
        hover: palette.neutral.lightAlpha[200],
      },
      background: {
        default: palette.neutral.darkAlpha[400],
        hover: palette.neutral.darkAlpha[300],
      },
      icon: { default: palette.neutral.grey[100] },
    },
    infoIcon: {
      border: palette.neutral.lightAlpha[550],
      icon: palette.neutral.grey[100],
      base: palette.neutral.lightAlpha[600],
    },
    animatedSpinner: {
      brand: {
        base: palette.neutral.lightAlpha[250],
        spinner: palette.dynamicContrast.primary[100],
      },
      contrast: {
        base: palette.neutral.darkAlpha[500],
        spinner: palette.neutral.grey[800],
      },
      link: {
        base: palette.brand.primary[25],
        spinner: palette.brand.primary[100],
      },
      white: {
        base: palette.neutral.lightAlpha[400],
        spinner: palette.neutral.lightAlpha[100],
      },
    },
    base: palette.neutral.lightAlpha[250],
    spinner: palette.brand.secondary[100],
    skeleton: {
      base: palette.neutral.grey[600],
      shimmer: palette.neutral.grey[100],
      pulse: palette.neutral.grey[550],
    },
    interactiveElement: { disabled: palette.neutral.darkAlpha[300] },
    voiceIndicator: {
      cell: {
        on: palette.neutral.darkAlpha[400],
        off: palette.neutral.lightAlpha[100],
        problem: palette.neutral.lightAlpha[100],
        disabled: palette.neutral.lightAlpha[100],
        loading: palette.neutral.lightAlpha[500],
      },
    },
    appLibraryCard: {
      default: {
        background: palette.neutral.grey[650],
        stroke: palette.neutral.lightAlpha[600],
      },
      hover: {
        background: palette.neutral.grey[550],
        stroke: palette.neutral.lightAlpha[600],
      },
      selected: {
        background: palette.neutral.grey[650],
        stroke: palette.neutral.lightAlpha[600],
        outline: palette.brand.primary[100],
      },
    },
    notificationCenter: {
      divider: palette.neutral.grey[600],
      background: palette.neutral.grey[750],
    },
    roomActivityBadge: {
      waiting: {
        background: palette.alert.informative[350],
        text: palette.neutral.grey[100],
      },
      waitingMessage: {
        background: palette.alert.informative[350],
        text: palette.neutral.grey[100],
      },
      zeroWaiting: {
        background: palette.neutral.grey[100],
        text: palette.neutral.grey[400],
      },
    },
    statusTag: {
      neutral: {
        background: palette.neutral.grey[750],
        copy: palette.neutral.grey[100],
      },
      negative: {
        background: palette.alert.negative[600],
        copy: palette.neutral.grey[100],
      },
      notice: {
        background: palette.alert.notice[550],
        copy: palette.neutral.grey[100],
      },
      informative: {
        background: palette.alert.informative[550],
        copy: palette.neutral.grey[100],
      },
      positive: {
        background: palette.alert.positive[550],
        copy: palette.neutral.grey[100],
      },
    },
    closedCaptions: { base: palette.neutral.grey[925] },
    snackbar: {
      background: palette.neutral.grey[850],
      border: 'rgba(255, 255, 255, 0)',
    },
    customConsentFormBuilder: {
      background: palette.neutral.grey[125],
      backgroundPreview: palette.neutral.grey[150],
    },
    whiteboardToolbar: {
      background: palette.neutral.grey[800],
      stroke: palette.neutral.lightAlpha[550],
    },
    appsSettingsListItem: {
      background: {
        default: palette.neutral.grey[125],
        hover: palette.neutral.grey[200],
        active: palette.neutral.grey[300],
      },
    },
    whiteboard: { background: palette.neutral.grey[800] },
    pill: {
      primary: {
        default: palette.neutral.grey[100],
        hover: palette.neutral.grey[200],
        selected: palette.neutral.grey[100],
        border: palette.neutral.grey[100],
        label: palette.neutral.grey[100],
        focused: palette.neutral.grey[100],
        disabled: palette.neutral.grey[100],
      },
      disabled: { label: palette.neutral.grey[450] },
    },
    dialButton: {
      background: palette.neutral.lightAlpha[600],
      default: palette.neutral.grey[550],
      hover: palette.brand.primary[100],
      pressed: palette.brand.primary[200],
      selected: palette.neutral.grey[650],
      disabled: palette.neutral.grey[650],
    },
    analyticsChart: {
      bars: palette.tint.coral[350],
      barsonhover: palette.neutral.darkAlpha[600],
    },
    videoFallback: {
      dialing: palette.alert.positive[250],
      speaking: palette.brand.primary[100],
    },
  }) as const;
